/*
    Controller to launch the dialog used to edit a device group name or description
*/

import Radio from 'backbone.radio';
import CloneDevDGDialog from '@/views/dialogs/clone_development_devicegroup_dialog';
import CloneDUTDGDialog from '@/views/dialogs/clone_dut_devicegroup_dialog';
import CloneProdDGDialog from '@/views/dialogs/clone_production_devicegroup_dialog';
// import CloneFactDGDialog from '@/views/dialogs/clone_factory_devicegroup_dialog';
import PaginationControls from '@/views/pagination_controls';
const globalCh = Radio.channel('global');
const apiCh = Radio.channel('api');

export default function clone_devicegroup_dialog(devicegroup_id) {

let devicegroup = apiCh.request('development_devicegroup', { id: devicegroup_id });
devicegroup.fetch().then(
    () => {
        create_dialog(devicegroup);
    },
    (err) => {
        console.warn(err);
    }
);

function create_dialog(devicegroup) {
    let product = devicegroup.rel.get('product');
    let type = devicegroup.type;
    let products = apiCh.request('product');
    let pagination_controls = new PaginationControls({
        collection: products
    });

    let options = {
        dialog_title: 'Clone Device Group: ',
        model: devicegroup,
        products,
        product,
        pagination_controls,
        type
    };

    let clone_dialog = undefined;
    switch (devicegroup.type) {
        case 'pre_production_devicegroup':
        case 'production_devicegroup':
            clone_dialog = new CloneProdDGDialog(options);
            break;
        case 'pre_dut_devicegroup':
        case 'dut_devicegroup':
            clone_dialog = new CloneDUTDGDialog(options);
            break;
        case 'pre_factoryfixture_devicegroup':
        case 'factoryfixture_devicegroup':
            console.log('hiiiiii sorry, not ready yet for factories');
            // clone_dialog = new CloneFactDGDialog(options);
            break;
        case 'development_devicegroup':
            clone_dialog = new CloneDevDGDialog(options);
    }
    globalCh.request('showDialog', clone_dialog);
}
}



